import React from 'react';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import DatosEmpadronador from './DatosEmpadronador'
import DatosSolicitud from './DatosDeLaSolicitud'
import DatosDPI from './DatosDPI'
import DatosUsuario from './DatosUsuario'
import EstatusUsuario from './EstatusUsuario'
import ResidenciaRenapExtranjero from './ResidenciaRenapExtranjero'

function DatosCiudadano(props) {   
    const classes = useStyles()
    return (

        <div>
            <DatosEmpadronador/>
            <DatosSolicitud />
            <DatosDPI />
            <DatosUsuario />
            {
                (props.datosCiudadanoTable?.datosSolicitudEmpadronamiento?.pais?.id === 2) ?
                    <ResidenciaRenapExtranjero />
                :''
            }            
            <EstatusUsuario open={props.open} setNroBoleta={props.setNroBoleta}/>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);